import React from "react";
import ActivityPhotoForm, { PHOTO_COMPETITION_ACTIVITY_ID } from "./ActivityPhotoForm.js";

const ActivityPhotoCompetitionForm = (props) => (
  <ActivityPhotoForm {...props} appId={PHOTO_COMPETITION_ACTIVITY_ID} />
);

export default ActivityPhotoCompetitionForm;
